import { Link } from "components/Link";
import { getYear } from "date-fns";
import { FooterConstants } from "footer-utils";
import type React from "react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { ParagraphSmall } from "styles/elements/Texts";
import { StyledFooter } from "./Footer.styled";

export const Footer: React.FC = () => {
  const { t } = useTranslation("common");
  const { contactLinks, genericLinks } = FooterConstants();
  const today = new Date();

  return (
    <StyledFooter>
      {/* Contact links */}
      <ParagraphSmall>{t(contactLinks.intro)}</ParagraphSmall>
      {contactLinks.links.map((link) => (
        <Link key={link.url} external={link.external} to={link.url} variant="default">
          <ParagraphSmall>{!link.staticLabel ? t(link.label) : link.label}</ParagraphSmall>
        </Link>
      ))}
      {/* Copyright notice */}
      <ParagraphSmall>
        {t("footer.copyrightNotice", { currentYear: getYear(today) })}
      </ParagraphSmall>
      {/* Miscellaneous links */}
      {genericLinks.links.map((link) => (
        <Fragment key={link.url}>
          {"|"}
          <Link external={link.external} size="xs" to={link.url}>
            {!link.staticLabel ? t(link.label) : link.label}
          </Link>
        </Fragment>
      ))}
    </StyledFooter>
  );
};
